import React, { useState, useEffect, useRef } from 'react';
import Projects from './Projects';
import Courses from './Courses';

export const TRAINING_REQUEST_FORM_LINK = "https://docs.google.com/forms/d/e/1FAIpQLSfJUMQx4kNQxGbGpP9dlIZYC_GJj-SA8ZwmTBipDYzhp72UVg/viewform?embedded=true";

const TechiesBaseAcademy = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    course: '',
    message: ''
  });

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value
    });
  };

  const handleSubmit = () => {
    alert('Thank you for your message! We will get back to you soon.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      course: '',
      message: ''
    });
  };


  // Dialog state for Enroll/Demo
  const [showDialog, setShowDialog] = useState(false);
  const timerRef = useRef(null);

  const handleEnrollClick = () => {
    setShowDialog(true);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setShowDialog(false), 30000);
  };

  const handleCloseDialog = () => {
    setShowDialog(false);
    if (timerRef.current) clearTimeout(timerRef.current);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false); // Close mobile menu on navigation
    }
  };


  const features = [
    {
      icon: '👨‍🏫',
      title: 'Expert Instructors',
      description: 'Learn from industry professionals with years of real-world experience in leading tech companies.'
    },
    {
      icon: '🛠️',
      title: 'Hands-on Projects',
      description: 'Work on real-world projects that you can showcase in your portfolio to potential employers.'
    },
    {
      icon: '💼',
      title: 'Job Placement Support',
      description: 'Get dedicated career guidance, resume review, and interview preparation to land your dream job.'
    },
    {
      icon: '⏰',
      title: 'Flexible Scheduling',
      description: 'Choose from weekday, weekend, or online classes that fit your busy schedule and lifestyle.'
    },
    {
      icon: '🎓',
      title: 'Industry Certification',
      description: 'Earn recognized certifications that validate your skills and boost your career prospects.'
    },
    {
      icon: '🤝',
      title: 'Lifetime Support',
      description: 'Access to alumni network, continued learning resources, and ongoing mentorship support.'
    }
    ,
    {
      icon: '🤖',
      title: 'AI-Powered Learning',
      description: 'Accelerate your coding journey with AI-based tools, personalized feedback, and smart code suggestions. Learn faster and smarter in the new age of AI-driven education.'
    }
  ];

  const testimonials = [
    {
      quote: "TechiesBase completely transformed my career. The hands-on approach and expert mentorship helped me land a senior developer role at a Fortune 500 company. The investment was totally worth it!",
      author: "Sneha Patel",
      position: "Senior Full Stack Developer at Infosys",
      avatar: "SP"
    },
    {
      quote: "The AI & Machine Learning course was exceptional. The instructors broke down complex concepts into digestible parts, and the practical projects gave me real experience. Now I'm working as an ML Engineer!",
      author: "Rahul Kumar",
      position: "ML Engineer at Qualcomm",
      avatar: "RK"
    },
    {
      quote: "The flexibility of weekend classes allowed me to upskill while working full-time. The AWS certification I earned here opened up new opportunities and increased my salary by 60%!",
      author: "Anita Mehta",
      position: "Cloud Architect at TCS",
      avatar: "AM"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">

      <style>{`
        html {
          scroll-behavior: smooth;
        }
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          line-height: 1.6;
          color: #333;
          overflow-x: hidden;
        }
        
        /* Device-specific styles */
        .mobile-view .navbar {
          padding: 0.2rem 0;
          height: auto !important;
          max-height: 60px !important;
          min-height: 0 !important;
        }
        
        .mobile-view .hero {
          padding-top: 100px !important;
          min-height: auto !important;
          height: auto !important; /* Allow it to expand as needed */
          max-height: none !important;
          overflow: visible !important;
        }
        
        .small-mobile-view .hero {
          padding-top: 90px !important;
          height: auto !important;
        }
        
        .mobile-view .hero-content {
          padding: 1rem !important;
          margin-top: 0 !important;
          grid-template-columns: 1fr !important; /* Force single column layout */
          gap: 1.5rem !important;
        }
        
        .mobile-view .hero h1 {
          font-size: 1.8rem !important;
          line-height: 1.3 !important;
          margin-top: 0 !important;
          margin-bottom: 0.5rem !important;
          display: block !important;
          visibility: visible !important;
        }
        
        .small-mobile-view .hero h1 {
          font-size: 1.6rem !important;
        }
        
        .tablet-view .hero {
          padding-top: 70px !important;
          min-height: auto !important;
        }
        
        .mobile-view .section-title {
          font-size: 1.8rem !important;
          margin-bottom: 1rem !important;
        }
        
        .mobile-view .features-grid {
          grid-template-columns: 1fr !important;
          gap: 1.5rem !important;
        }
        
        .mobile-view .nav-menu {
          gap: 1.5rem !important;
        }
        
        .small-mobile-view .card {
          padding: 1rem !important;
        }
        
        .mobile-view .mobile-menu {
          top: 45px !important;
        }
        
        /* Animation adjustments for mobile */
        .mobile-view .feature-card {
          transition: transform 0.2s ease !important;
        }

        .navbar {
          position: fixed;
          top: 0;
          width: 100%;
          background: ${isScrolled ? 'rgba(15, 23, 42, 0.98)' : 'rgba(15, 23, 42, 0.92)'};
          backdrop-filter: blur(12px);
          -webkit-backdrop-filter: blur(12px);
          z-index: 1000;
          padding: 0.25rem 0;
          transition: all 0.3s ease;
          box-shadow: ${isScrolled ? '0 4px 20px rgba(0, 0, 0, 0.15)' : 'none'};
        }

        .nav-container {
          max-width: 1200px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 1.5rem;
          height: 100%;
        }

        .logo {
          font-size: 1.4rem;
          font-weight: bold;
          color: #60a5fa;
          text-decoration: none;
          cursor: pointer;
          padding: 0.1rem 0;
          display: flex;
          align-items: center;
          letter-spacing: 0.5px;
        }

        .nav-menu {
          display: flex;
          list-style: none;
          gap: 2.5rem;
          padding: 0;
          margin: 0;
          height: 100%;
          align-items: center;
        }

        .mobile-menu-icon {
          display: none;
          font-size: 1.8rem;
          color: white;
          background: none;
          border: none;
          cursor: pointer;
          padding: 0.3rem;
          margin-left: auto;
        }

        .mobile-nav-menu {
          display: none;
        }

        .nav-item {
          color: white;
          text-decoration: none;
          font-weight: 500;
          transition: all 0.3s ease;
          cursor: pointer;
          padding: 0.3rem 0.6rem;
          border-radius: 8px;
          position: relative;
        }

        .nav-item:hover {
          color: #60a5fa;
          background: rgba(255, 255, 255, 0.08);
        }
        
        .nav-item:after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 50%;
          width: 0;
          height: 2px;
          background: linear-gradient(90deg, #3b82f6 10%, #a855f7 90%);
          transition: all 0.3s ease;
          transform: translateX(-50%);
        }
        
        .nav-item:hover:after {
          width: 80%;
        }

        .cta-button {
          background: linear-gradient(135deg, #3b82f6, #8b5cf6);
          color: white;
          padding: 0.4rem 1.2rem;
          border: none;
          border-radius: 50px;
          font-weight: 600;
          cursor: pointer;
          transition: transform 0.3s ease;
          font-size: 0.9rem;
        }

        .cta-button:hover {
          transform: translateY(-2px);
        }

        .hero {
          background: linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%);
          min-height: 100vh;
          display: flex;
          align-items: center;
          position: relative;
          overflow: hidden;
          padding-top: 50px;
          padding-bottom: 2rem;
        }

        .hero::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.03'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E") repeat;
        }
        
        .hero::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 150px;
          background: linear-gradient(to top, rgba(15, 23, 42, 1), rgba(15, 23, 42, 0));
          z-index: 1;
          pointer-events: none;
        }

        .hero-content {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 2rem;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 4rem;
          align-items: center;
          position: relative;
          z-index: 2;
          width: 100%;
        }

        .hero-text h1 {
          font-size: 3.5rem;
          font-weight: 900;
          color: white;
          margin-bottom: 1.5rem;
          line-height: 1.2;
        }

        .highlight {
          background: linear-gradient(135deg, #60a5fa, #a855f7);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .hero-text p {
          font-size: 1.2rem;
          color: #cbd5e1;
          margin-bottom: 2rem;
        }

        .hero-buttons {
          display: flex;
          gap: 1rem;
          margin-bottom: 2rem;
        }

        .btn-primary {
          background: linear-gradient(135deg, #3b82f6, #8b5cf6);
          color: white;
          padding: 1rem 2rem;
          border: none;
          border-radius: 50px;
          font-size: 1.1rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .btn-secondary {
          background: transparent;
          color: white;
          padding: 1rem 2rem;
          border: 2px solid #60a5fa;
          border-radius: 50px;
          font-size: 1.1rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .btn-primary:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 25px rgba(59, 130, 246, 0.4);
        }

        .btn-secondary:hover {
          background: #60a5fa;
          transform: translateY(-3px);
        }

        .hero-stats {
          display: flex;
          gap: 2rem;
          margin-top: 2rem;
          flex-wrap: wrap;
          justify-content: center;
        }

        .stat {
          text-align: center;
          background: rgba(255, 255, 255, 0.06);
          padding: 1rem 1.5rem;
          border-radius: 12px;
          border: 1px solid rgba(255, 255, 255, 0.1);
          min-width: 120px;
          transition: all 0.3s ease;
        }
        
        .stat:hover {
          background: rgba(255, 255, 255, 0.1);
          transform: translateY(-3px);
        }

        .stat-number {
          font-size: 2rem;
          font-weight: bold;
          color: #60a5fa;
          text-shadow: 0 2px 10px rgba(96, 165, 250, 0.3);
        }

        .stat-label {
          color: #94a3b8;
          font-size: 0.9rem;
          margin-top: 0.3rem;
        }

        .hero-visual {
          position: relative;
        }

        .floating-card {
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 20px;
          padding: 2rem;
          margin-bottom: 1.5rem;
          animation: float 6s ease-in-out infinite;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        }

        .floating-card:hover {
          background: rgba(255, 255, 255, 0.15);
          border: 1px solid rgba(255, 255, 255, 0.3);
          transform: translateY(-5px);
        }

        .floating-card:nth-child(2) {
          animation-delay: -2s;
        }

        .floating-card:nth-child(3) {
          animation-delay: -4s;
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-15px); }
        }
        
        @media (prefers-reduced-motion: reduce) {
          .floating-card {
            animation: none;
          }
        }

        .card-icon {
          width: 60px;
          height: 60px;
          background: linear-gradient(135deg, #3b82f6, #8b5cf6);
          border-radius: 15px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 1rem;
          font-size: 1.5rem;
        }

        .card-title {
          color: white;
          font-weight: 600;
          margin-bottom: 0.5rem;
        }

        .card-desc {
          color: #cbd5e1;
          font-size: 0.9rem;
        }

        .courses {
          padding: 6rem 0;
          background: #f8fafc;
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 2rem;
        }

        .section-header {
          text-align: center;
          margin-bottom: 4rem;
        }

        .section-title {
          font-size: 2.5rem;
          font-weight: 800;
          color: #1e293b;
          margin-bottom: 1rem;
        }

        .section-subtitle {
          font-size: 1.2rem;
          color: #64748b;
          max-width: 600px;
          margin: 0 auto;
        }

        .course-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
          gap: 2rem;
        }

        .course-card {
          background: white;
          border-radius: 20px;
          padding: 2rem;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          position: relative;
          overflow: hidden;
        }

        .course-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(135deg, #3b82f6, #8b5cf6);
        }

        .course-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
        }

        .course-icon {
          width: 80px;
          height: 80px;
          background: linear-gradient(135deg, #3b82f6, #8b5cf6);
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 1.5rem;
          font-size: 2rem;
        }

        .course-title {
          font-size: 1.5rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 1rem;
        }

        .course-desc {
          color: #64748b;
          margin-bottom: 1.5rem;
          line-height: 1.6;
        }

        .course-features {
          list-style: none;
          margin-bottom: 2rem;
        }

        .course-features li {
          color: #475569;
          margin-bottom: 0.5rem;
          position: relative;
          padding-left: 1.5rem;
        }

        .course-features li::before {
          content: '✓';
          position: absolute;
          left: 0;
          color: #10b981;
          font-weight: bold;
        }

        .course-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .course-price {
          font-size: 1.5rem;
          font-weight: 700;
          color: #3b82f6;
        }

        .course-button {
          background: linear-gradient(135deg, #3b82f6, #8b5cf6);
          color: white;
          padding: 0.7rem 1.5rem;
          border: none;
          border-radius: 50px;
          font-weight: 600;
          cursor: pointer;
          transition: transform 0.3s ease;
        }

        .course-button:hover {
          transform: scale(1.05);
        }

        .features {
          padding: 6rem 0;
          background: linear-gradient(135deg, #1e293b, #334155);
        }

        .features-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 3rem;
        }

        .feature-card {
          text-align: center;
          padding: 2rem;
        }

        .feature-icon {
          width: 100px;
          height: 100px;
          background: linear-gradient(135deg, #60a5fa, #a855f7);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 2rem;
          font-size: 2.5rem;
        }

        .feature-title {
          color: white;
          font-size: 1.5rem;
          font-weight: 700;
          margin-bottom: 1rem;
        }

        .feature-desc {
          color: #cbd5e1;
          line-height: 1.6;
        }

        .testimonials {
          padding: 6rem 0;
          background: #f8fafc;
        }

        .testimonial-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
          gap: 2rem;
        }

        .testimonial-card {
          background: white;
          padding: 2rem;
          border-radius: 20px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
          position: relative;
        }

        .testimonial-quote {
          font-size: 1.1rem;
          color: #475569;
          margin-bottom: 1.5rem;
          line-height: 1.6;
          font-style: italic;
        }

        .testimonial-author {
          display: flex;
          align-items: center;
          gap: 1rem;
        }

        .author-avatar {
          width: 60px;
          height: 60px;
          background: linear-gradient(135deg, #3b82f6, #8b5cf6);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: bold;
          font-size: 1.2rem;
        }

        .author-info h4 {
          color: #1e293b;
          font-weight: 600;
          margin-bottom: 0.25rem;
        }

        .author-info p {
          color: #64748b;
          font-size: 0.9rem;
        }

        .contact {
          padding: 6rem 0;
          background: linear-gradient(135deg, #0f172a, #1e293b);
        }

        .contact-content {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 4rem;
          align-items: center;
        }

        .contact-info h2 {
          color: white;
          font-size: 2.5rem;
          font-weight: 800;
          margin-bottom: 1.5rem;
        }

        .contact-info p {
          color: #cbd5e1;
          font-size: 1.1rem;
          margin-bottom: 2rem;
          line-height: 1.6;
        }

        .contact-details {
          list-style: none;
        }

        .contact-details li {
          color: #cbd5e1;
          margin-bottom: 1rem;
          display: flex;
          align-items: center;
          gap: 1rem;
        }

        .contact-icon {
          width: 40px;
          height: 40px;
          background: linear-gradient(135deg, #3b82f6, #8b5cf6);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1rem;
        }

        .contact-form {
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 20px;
          padding: 2rem;
        }

        .form-group {
          margin-bottom: 1.5rem;
        }

        .form-group label {
          display: block;
          color: white;
          margin-bottom: 0.5rem;
          font-weight: 600;
        }

        .form-group input,
        .form-group textarea {
          width: 100%;
          padding: 1rem;
          border: 1px solid rgba(255, 255, 255, 0.3);
          border-radius: 10px;
          background: rgba(255, 255, 255, 0.1);
          color: white;
          font-size: 1rem;
        }

        .form-group input::placeholder,
        .form-group textarea::placeholder {
          color: rgba(255, 255, 255, 0.7);
        }

        .submit-button {
          width: 100%;
          background: linear-gradient(135deg, #3b82f6, #8b5cf6);
          color: white;
          padding: 1rem;
          border: none;
          border-radius: 10px;
          font-size: 1.1rem;
          font-weight: 600;
          cursor: pointer;
          transition: transform 0.3s ease;
        }

        .submit-button:hover {
          transform: translateY(-2px);
        }

        .footer {
          background: #0f172a;
          padding: 2rem 0;
          text-align: center;
        }

        .footer p {
          color: #64748b;
          margin-bottom: 1rem;
        }

        .social-links {
          display: flex;
          justify-content: center;
          gap: 1rem;
        }

        .social-link {
          width: 40px;
          height: 40px;
          background: linear-gradient(135deg, #3b82f6, #8b5cf6);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          text-decoration: none;
          transition: transform 0.3s ease;
          cursor: pointer;
        }

        .social-link:hover {
          transform: scale(1.1);
        }

        /* Tablet Styles */
        @media (max-width: 1024px) {
          .container {
            padding: 0 1.5rem;
          }
          .hero-text h1 {
            font-size: 2.8rem;
          }
          .course-grid,
          .features-grid,
          .testimonial-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
        
        /* Smaller Tablet Styles */
        @media (max-width: 900px) {
          .container {
            padding: 0 1rem;
          }
          .hero-content {
            grid-template-columns: 1fr;
            gap: 3rem;
          }
          .ai-hero-highlight {
            text-align: left;
          }
        }

        /* Mobile Styles */
        @media (max-width: 768px) {
          .navbar {
            padding: 0.3rem 0;
          }
          .nav-container {
            padding: 0 1.5rem;
          }
          .logo {
            font-size: 1.3rem;
            padding: 0;
          }
          .nav-menu {
            display: none;
          }
          .mobile-menu-icon {
            display: block;
            padding: 0.2rem;
            margin-left: auto;
          }
          .mobile-nav-menu {
            display: flex;
            flex-direction: column;
            position: absolute;
            top: 38px;
            left: 0;
            width: 100vw;
            background: rgba(15, 23, 42, 0.98);
            z-index: 2000;
            padding: 0.8rem 0;
            box-shadow: 0 8px 24px rgba(0,0,0,0.15);
            gap: 1.8rem;
            align-items: center;
            animation: fadeIn 0.3s;
            backdrop-filter: blur(12px);
            -webkit-backdrop-filter: blur(12px);
          }
          
          .mobile-nav-menu .nav-item {
            font-size: 1rem;
            padding: 0.6rem 1.5rem;
            width: 80%;
            text-align: center;
            border-radius: 10px;
            background: rgba(255, 255, 255, 0.05);
            margin: 0 auto;
            border: 1px solid rgba(255, 255, 255, 0.1);
          }
          
          .mobile-nav-menu .nav-item:active {
            background: rgba(59, 130, 246, 0.2);
            transform: scale(0.98);
          }
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(-15px); }
            to { opacity: 1; transform: translateY(0); }
          }
          
          @keyframes slideIn {
            from { opacity: 0; transform: translateX(-20px); }
            to { opacity: 1; transform: translateX(0); }
          }
          .hero {
            padding-top: 40px;
            min-height: 100vh;
            height: auto;
            padding-bottom: 4rem;
          }
          .hero-content {
            grid-template-columns: 1fr;
            text-align: center;
            gap: 2.5rem;
            padding: 0 1.5rem;
          }
          .hero-text h1 {
            font-size: 2.5rem;
            margin-top: 1.5rem;
            line-height: 1.3;
            word-break: break-word;
            animation: slideIn 0.6s ease-out;
          }
          .hero-text p {
            font-size: 1.1rem;
            max-width: 92%;
            margin: 1.2rem auto;
            animation: slideIn 0.6s ease-out 0.2s backwards;
          }
          .ai-hero-highlight {
            padding: 0.8em 1.2em;
            font-size: 1rem;
            flex-direction: row;
            text-align: left;
            align-items: center;
            gap: 0.8em;
            margin: 1.5em auto;
            max-width: 90%;
          }
          .ai-hero-highlight .ai-highlight-text {
            letter-spacing: 0;
          }
          .hero-buttons {
            justify-content: center;
            flex-direction: row;
            flex-wrap: wrap;
            gap: 0.7rem;
          }
          .hero-buttons .btn-primary,
          .hero-buttons .btn-secondary {
            min-width: 150px;
          }
          .hero-stats {
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: center;
            gap: 1.5rem;
          }
          .hero-visual {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .floating-card {
            width: 90%;
            max-width: 320px;
            margin: 0 auto 1.2rem;
          }
          .contact-content {
            grid-template-columns: 1fr;
            gap: 2rem;
          }
          .course-grid,
          .features-grid,
          .testimonial-grid {
            grid-template-columns: 1fr;
          }
          .course-card, .feature-card, .testimonial-card {
            padding: 1.2rem;
          }
          .section-title {
            font-size: 1.5rem;
          }
          .section-subtitle {
            font-size: 1rem;
          }
          .section-header {
            margin-bottom: 2rem;
          }
          .footer {
            padding: 1rem 0;
          }
        }
        
        /* Small Mobile Styles */
        @media (max-width: 480px) {
          .hero-text h1 {
            font-size: 2rem;
            margin-top: 1rem;
            padding: 0 0.5rem;
          }
          .hero-text p {
            font-size: 1rem;
            padding: 0 0.5rem;
            max-width: 100%;
          }
          .hero-buttons {
            flex-direction: column;
            width: 100%;
          }
          .hero-buttons .btn-primary,
          .hero-buttons .btn-secondary {
            width: 90%;
            margin: 0 auto;
            min-width: auto;
          }
          .ai-hero-highlight {
            flex-direction: column;
            text-align: center;
            padding: 1em 1em;
            max-width: 90%;
          }
          .ai-hero-highlight .ai-icon {
            font-size: 1.5em;
            margin-bottom: 0.4em;
          }
          .ai-hero-highlight .ai-highlight-text {
            font-size: 0.9rem;
          }
          .floating-card {
            padding: 1.5rem;
            max-width: 280px;
          }
          .card-title {
            font-size: 1.1rem;
          }
          .card-desc {
            font-size: 0.9rem;
          }
          .btn-primary, .btn-secondary {
            padding: 0.8rem 1.6rem;
            font-size: 1rem;
          }
          .stat-number {
            font-size: 1.5rem;
          }
          .stat-label {
            font-size: 0.8rem;
          }
          .feature-icon {
            width: 80px;
            height: 80px;
            font-size: 2rem;
          }
          .feature-title {
            font-size: 1.2rem;
          }
          .feature-desc {
            font-size: 0.95rem;
          }
          .section-title {
            font-size: 1.3rem;
          }
          .enroll-dialog {
            padding: 1.5rem;
          }
        }
        @media (max-width: 768px) {
          .hero-content {
            display: flex !important;
            flex-direction: row !important;
            align-items: center !important;
            justify-content: center !important;
            width: 100% !important;
            padding: 0 1rem !important;
            box-sizing: border-box;
            gap: 1.2rem !important;
          }
          .hero-text {
            width: auto;
            text-align: center;
            margin-bottom: 0;
            flex: 1 1 60%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          }
          .hero-buttons {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: auto;
            gap: 0.8rem;
            margin-top: 0;
            flex: 1 1 40%;
          }
          .hero-buttons button {
            width: 90vw;
            max-width: 180px;
            font-size: 1.1rem;
            margin: 0 0 0.5rem 0;
          }
        }
        @media (max-width: 480px) {
          .hero-content {
            flex-direction: column !important;
            align-items: center !important;
          }
          .hero-text {
            text-align: center;
            align-items: center;
            justify-content: center;
          }
          .hero-buttons {
            align-items: center;
          }
          .hero-buttons button {
            width: 98vw;
            max-width: 98vw;
            font-size: 1rem;
          }
        }
      `}</style>

      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container" style={{position: 'relative'}}>
          <div className="logo" onClick={() => scrollToSection('home')}>
            🚀 TechiesBase
          </div>
          <ul className="nav-menu">
            <li className="nav-item" onClick={() => scrollToSection('home')}>Home</li>
            <li className="nav-item" onClick={() => scrollToSection('courses')}>Courses</li>
            <li className="nav-item" onClick={() => scrollToSection('features')}>Features</li>
            <li className="nav-item" onClick={() => scrollToSection('testimonials')}>Reviews</li>
            <li className="nav-item" onClick={() => scrollToSection('projects')}>Project</li>
            <li className="nav-item" onClick={() => scrollToSection('contact')}>Contact</li>
          </ul>
          <button className="mobile-menu-icon" aria-label="Open menu" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
            {mobileMenuOpen ? '✖' : '☰'}
          </button>
          {mobileMenuOpen && (
            <ul className="mobile-nav-menu">
              <li className="nav-item" onClick={() => scrollToSection('home')}>Home</li>
              <li className="nav-item" onClick={() => scrollToSection('courses')}>Courses</li>
              <li className="nav-item" onClick={() => scrollToSection('features')}>Features</li>
              <li className="nav-item" onClick={() => scrollToSection('testimonials')}>Reviews</li>
              <li className="nav-item" onClick={() => scrollToSection('projects')}>Project</li>
              <li className="nav-item" onClick={() => scrollToSection('contact')}>Contact</li>
            </ul>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="hero">
        <div className="hero-content">
          <div className="hero-text">
            <h1>Master <span className="highlight">Future Technologies</span> with Expert-Led Training</h1>
            <p>Transform your career with our comprehensive technology training programs. Learn from industry experts, work on real projects, and land your dream job in tech.</p>
            <div className="ai-hero-highlight">
              <span className="ai-icon">🤖</span>
              <span className="ai-highlight-text">AI-powered learning: Get personalized feedback, smart code suggestions, and accelerate your coding journey with the latest AI tools.</span>
            </div>
      <style>{`
        .ai-hero-highlight {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          background: linear-gradient(90deg, #3b82f6 10%, #a855f7 90%);
          color: #fff;
          border-radius: 12px;
          padding: 0.7em 1.2em;
          margin: 1.2em 0 1.5em 0;
          font-size: 1.15rem;
          font-weight: 600;
          box-shadow: 0 2px 12px rgba(59,130,246,0.20);
          gap: 0.7em;
          transition: all 0.3s ease;
        }
        .ai-hero-highlight .ai-icon {
          font-size: 1.7em;
          filter: drop-shadow(0 2px 6px #3b82f6cc);
          transition: transform 0.3s ease;
        }
        .ai-hero-highlight:hover .ai-icon {
          transform: scale(1.1);
        }
        .ai-hero-highlight .ai-highlight-text {
          letter-spacing: 0.01em;
          flex: 1;
        }
        @media (max-width: 480px) {
          .ai-hero-highlight {
            flex-direction: column;
            padding: 0.8em 1em;
            text-align: center;
          }
          .ai-hero-highlight .ai-icon {
            margin-bottom: 0.3em;
          }
          .ai-hero-highlight .ai-highlight-text {
            font-size: 0.9rem;
          }
        }
        
        /* Modern responsive approach using device detection instead of just media queries */
        .mobile-view .ai-hero-highlight, 
        .small-mobile-view .ai-hero-highlight {
          flex-direction: column;
          padding: 0.8em 1em;
          text-align: center;
          margin-top: 0.5rem;
        }
        
        .mobile-view .ai-icon,
        .small-mobile-view .ai-icon {
          margin-bottom: 0.3em;
        }
        
        /* Reduce animations on mobile for better performance */
        .mobile-view *,
        .small-mobile-view * {
          transition-duration: 0.2s !important;
        }
      `}</style>
            <div className="hero-buttons">
              <button className="btn-primary" onClick={handleEnrollClick}>Start Learning Today</button>
              <button className="btn-secondary" onClick={handleEnrollClick}>Watch Demo</button>
      {showDialog && (
        <div className="enroll-dialog-overlay" onClick={handleCloseDialog}>
          <div className="enroll-dialog" onClick={e => e.stopPropagation()}>
            <button className="enroll-dialog-close" onClick={handleCloseDialog}>&times;</button>
            <h3>Training Request</h3>
            <p>
              Please complete the <span role="img" aria-label="point right" style={{fontSize: '1.3em', verticalAlign: 'middle', marginRight: '0.2em'}}>👉</span>
              <a className="highlight-link" href={TRAINING_REQUEST_FORM_LINK} target="_blank" rel="noopener noreferrer">Training Request Form</a> to enroll for the Demo session or Enrolling into course(s).
            </p>
            <p style={{fontSize: '0.9em', color: '#888'}}>This dialog will close automatically after 30 seconds.</p>
          </div>
          <style>{`
            .enroll-dialog-overlay {
              position: fixed;
              top: 0; left: 0; right: 0; bottom: 0;
              background: rgba(0,0,0,0.4);
              display: flex;
              align-items: center;
              justify-content: center;
              z-index: 1000;
            }
            .enroll-dialog {
              background: #1e293b;
              color: #f1f5f9;
              padding: 2rem 2.5rem;
              border-radius: 10px;
              box-shadow: 0 4px 24px rgba(0,0,0,0.18);
              max-width: 90vw;
              min-width: 300px;
              position: relative;
              text-align: center;
            }
            .enroll-dialog h3 {
              color: #60a5fa;
            }
            .enroll-dialog p, .enroll-dialog a {
              color: #f1f5f9;
            }
            .enroll-dialog a {
              color: #60a5fa;
              text-decoration: underline;
              font-weight: 500;
            }
            .enroll-dialog .highlight-link {
              background: linear-gradient(90deg, #3b82f6 30%, #8b5cf6 100%);
              color: #fff !important;
              padding: 0.15em 0.5em;
              border-radius: 6px;
              font-weight: bold;
              text-decoration: none;
              box-shadow: 0 2px 8px rgba(59,130,246,0.10);
              margin: 0 2px;
              transition: background 0.2s;
            }
            .enroll-dialog .highlight-link:hover {
              background: linear-gradient(90deg, #8b5cf6 30%, #3b82f6 100%);
              color: #fff;
            }
            .enroll-dialog-close {
              position: absolute;
              top: 0.5rem;
              right: 0.7rem;
              background: none;
              border: none;
              font-size: 2rem;
              color: #888;
              cursor: pointer;
            }
            .enroll-dialog a {
              color: #1976d2;
              text-decoration: underline;
              font-weight: 500;
            }
          `}</style>
        </div>
      )}
            </div>
            <div className="hero-stats">
              <div className="stat">
                <div className="stat-number">10K+</div>
                <div className="stat-label">Students Trained</div>
              </div>
              <div className="stat">
                <div className="stat-number">95%</div>
                <div className="stat-label">Job Placement</div>
              </div>
              <div className="stat">
                <div className="stat-number">50+</div>
                <div className="stat-label">Expert Instructors</div>
              </div>
            </div>
          </div>
          <div className="hero-visual">
            <div className="floating-card">
              <div className="card-icon">💻</div>
              <div className="card-title">Full Stack Development</div>
              <div className="card-desc">Master modern web technologies</div>
            </div>
            <div className="floating-card">
              <div className="card-icon">⚙️</div>
              <div className="card-title">DevOps, Infrastructure</div>
              <div className="card-desc">Automate and manage deployments and infrastructure</div>
            </div>
            <div className="floating-card">
              <div className="card-icon">☁️</div>
              <div className="card-title">Cloud Computing</div>
              <div className="card-desc">Deploy scalable solutions</div>
            </div>
          </div>
        </div>
      </section>

      {/* Courses Section */}
      <Courses handleEnrollClick={handleEnrollClick} />

      {/* Features Section */}
      <section id="features" className="features">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title" style={{color: 'white'}}>Why Choose TechiesBase?</h2>
            <p className="section-subtitle" style={{color: '#cbd5e1'}}>We provide comprehensive training with practical experience and career support</p>
          </div>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon">{feature.icon}</div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-desc">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section id="testimonials" className="testimonials">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">What Our Students Say</h2>
            <p className="section-subtitle">Real success stories from our graduates who transformed their careers</p>
          </div>
          <div className="testimonial-grid">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testimonial-card">
                <p className="testimonial-quote">"{testimonial.quote}"</p>
                <div className="testimonial-author">
                  <div className="author-avatar">{testimonial.avatar}</div>
                  <div className="author-info">
                    <h4>{testimonial.author}</h4>
                    <p>{testimonial.position}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="contact">
        <div className="container">
          <div className="contact-content">
            <div className="contact-info" style={{width: '100%'}}>
              <h2>Ready to Start Your Tech Journey?</h2>
              <p>Join thousands of successful graduates who transformed their careers with TechiesBase. Get in touch with us today to learn more about our programs and how we can help you achieve your goals.
                <br></br><br></br>Please complete the &nbsp;
              <span>
                    <a 
                      href={TRAINING_REQUEST_FORM_LINK}
                      target="_blank" rel="noopener noreferrer" 
                      style={{
                        color: '#3b82f6',
                        textDecoration: 'underline',
                        fontWeight: 600,
                        cursor: 'pointer'
                      }}
                    >Training Request form</a> to fast track your training request.
                    <br />
                  </span>
                  </p>
              <ul className="contact-details">
                <li>
                  <div className="contact-icon">✉️</div>
                  <span>
                    <a href="mailto:trainings.techiesbase@gmail.com" style={{color: '#3b82f6', textDecoration: 'underline', fontWeight: 600}}>trainings.techiesbase@gmail.com</a>
                  </span>
                </li>
                <li>
                  <div className="contact-icon">🕒</div>
                  <span>Mon - Sat: 9:00 AM - 6:00 PM</span>
                </li>
              </ul>
            </div>
          </div>
          
        </div>
        <section id="projects">
          <Projects />
        </section>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <p>&copy; 2025 TechiesBase. All rights reserved. | Empowering careers through technology education.</p>
          <p style={{fontSize: '0.95em', color: '#64748b', marginTop: '0.5em'}}>
            All trademarks, logos, and brand names are the property of their respective owners. Any copyright items used on this site are for representation and easy identification only.
          </p>
          <div className="social-links">
            <div className="social-link">📘</div>
            <div className="social-link">🐦</div>
            <div className="social-link">💼</div>
            <div className="social-link">📸</div>
          </div>
        </div>
      </footer>
      
      
    </div>
  );
};


export default TechiesBaseAcademy;